import { providerApi } from '@/api/ProviderApi'
import type { VrdhSchedulingSlot } from '@/api/types/ProviderApi'
import { useMutation, useQueryClient } from '@tanstack/react-query'

const useBookVrdhSchedulingSlot = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({
			slot,
			rescheduledEventId,
			callReason,
		}: {
			slot: VrdhSchedulingSlot
			rescheduledEventId?: string
			callReason?: string
		}) => {
			if (rescheduledEventId) {
				return providerApi.rescheduleVrdhSchedulingSlot({
					startTimeUtc: slot.startTimeUtc,
					vrdhId: slot.vrdhId,
					rescheduledEventId,
					vrdhCallReason: callReason,
				})
			}

			return providerApi.bookVrdhSchedulingSlot({
				...slot,
				vrdhCallReason: callReason,
			})
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['upcoming-vrdh-calls'],
			})
		},
	})
}

export { useBookVrdhSchedulingSlot }
